import React from 'react'
import { Box } from '@mui/material'
import { EmtTypography } from 'emt-components-v2'
import NextLink from 'next/link'
import { Routes } from '@/assets/configs'

const AlreadyAccountBox: React.FC = () => (
  <Box>
    <EmtTypography
      variant="caption"
      color="textSecondary"
      sx={{
        display: 'block',
        lineHeight: '1.3',
      }}
    >
      Vous avez déjà un compte sur Super Sitter ?
    </EmtTypography>
    <NextLink href={Routes.Connection.SignIn} passHref legacyBehavior>
      <EmtTypography
        variant="caption"
        color="purple.main"
        sx={{
          cursor: 'pointer',
          display: 'block',
          lineHeight: '1.3',
          textDecoration: 'underline',
          fontWeight: '700',
        }}
      >
        Connectez-vous
      </EmtTypography>
    </NextLink>
  </Box>
)

export default AlreadyAccountBox
